import * as React from 'react';

export function SvgZoomLogo(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        fill="url(#a)"
        d="M22 12a19.8 19.8 0 0 1-.25 3.14 8.002 8.002 0 0 1-6.61 6.61c-2.08.334-4.2.334-6.28 0a8.003 8.003 0 0 1-6.61-6.61 19.79 19.79 0 0 1 0-6.28 8.002 8.002 0 0 1 6.61-6.61 19.79 19.79 0 0 1 6.28 0 8.002 8.002 0 0 1 6.61 6.61c.167 1.038.25 2.088.25 3.14Z"
      />
      <path
        fill="#fff"
        d="M7.972 13.531h-2.48a.427.427 0 0 1-.303-.732l1.718-1.718H5.675a.613.613 0 0 1-.612-.612H7.35a.428.428 0 0 1 .304.732L5.935 12.92H7.36c.338 0 .612.274.612.612Zm10.965-1.914a1.196 1.196 0 0 0-2.082-.798 1.196 1.196 0 0 0-2.083.798v1.914a.613.613 0 0 0 .612-.612v-1.302a.583.583 0 0 1 1.164 0v1.302c0 .338.274.612.613.612v-1.914a.583.583 0 0 1 1.164 0v1.302c0 .338.274.612.612.612v-1.914ZM14.465 12a1.577 1.577 0 1 1-3.153 0 1.577 1.577 0 0 1 3.153 0Zm-.612 0a.965.965 0 1 0-1.93 0 .965.965 0 0 0 1.93 0Zm-2.787 0a1.578 1.578 0 1 1-3.155 0 1.578 1.578 0 0 1 3.155 0Zm-.613 0a.965.965 0 1 0-1.93 0 .965.965 0 0 0 1.93 0Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1={6.734}
          x2={17.268}
          y1={21.122}
          y2={2.878}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0845BF" />
          <stop offset={0.6} stopColor="#0B5CFF" />
          <stop offset={1} stopColor="#4F90EE" />
        </linearGradient>
      </defs>
    </svg>
  );
}
